module.exports = __webpack_public_path__ + "static/img/img_jingxiaoshang.0e33fdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img_jingxiaoshang.jpg
// module id = 169
// module chunks = 1